import useTranslation from 'customHooks/translate';

const CostDetailsInfo = ({ cost }) => {
  const translation = useTranslation();

  return (
    <div className="flex flex-col gap-[10px] px-[16px] py-[24px] md:border-b md:border-l md:border-b-[#f5f7f9] md:border-l-[#f5f7f9]">
      <div className="flex h-max flex-col justify-between gap-[4px] rounded-[4px] bg-[#F5F7F9] p-[16px]">
        <p className="text-[18px] font-semibold text-[#1D1D1D]">
          {translation.InvoiceDetails.Total}
        </p>
        <div className="flex items-center gap-[6px]">
          <p className="text-[16px] font-medium text-[#1D1D1D]">
            {translation.InvoiceDetails.TotalNet}:
          </p>
          <p className="text-[16px] font-normal text-[#1D1D1D]">
            {new Intl.NumberFormat('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(cost.total || 0)}{' '}
            {cost.currency}
          </p>
        </div>
        <div className="flex items-center gap-[6px]">
          <p className="text-[16px] font-medium text-[#1D1D1D]">
            {translation.InvoiceDetails.Discount}:
          </p>
          <p className="text-[16px] font-normal text-[#1D1D1D]">
            {new Intl.NumberFormat('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(cost.discount || 0)}{' '}
            {cost.currency}
          </p>
        </div>
        <div className="flex items-center gap-[6px]">
          {cost?.taxDetails?.map((taxDetail, index) => (
            <p
              key={index}
              className="text-[16px] font-medium text-[#1D1D1D]"
            >
              {taxDetail?.taxType}:
            </p>
          ))}
          {cost?.taxDetails?.map((taxDetail, index) => (
            <p
              key={index}
              className="text-[16px] font-normal text-[#1D1D1D]"
            >
              {new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(taxDetail?.taxAmount || 0)}{' '}
              {cost.currency}
            </p>
          ))}
        </div>
        <div className="flex items-center gap-[6px]">
          <p className="text-[16px] font-medium text-[#1D1D1D]">
            {translation.reports.AllAmount}:
          </p>
          <p className="text-[16px] font-normal text-[#1D1D1D]">
            {new Intl.NumberFormat('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(cost.summary || 0)}{' '}
            {cost.currency}
          </p>
        </div>
      </div>
      <div className="flex h-max flex-col justify-between gap-[4px] rounded-[4px] bg-[#F5F7F9] p-[16px]">
        <p className="text-[18px] font-semibold text-[#1D1D1D]">
          {translation.reports.RemindAmount}:
        </p>
        <p className="text-[16px] font-normal text-[#1D1D1D]">
          {new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(cost.balance || 0)}{' '}
          {cost.currency}
        </p>
      </div>
    </div>
  );
};

export default CostDetailsInfo;
